var map = {
	"./1-1 Meetings - 3rd Prolog Conference.jpg": 9104,
	"./Barnhouse - 360deg Photo Booth.jpg": 6353,
	"./Gala Banquet - 3rd Prolog Conference.jpg": 8320,
	"./Group Photo - 3rd Prolog Conference.jpg": 6128,
	"./Karaoke - 3rd Prolog Conference.jpg": 651,
	"./Mt Lavinia - 360deg Photo Booth.jpg": 8831,
	"./Opening Ceremony - 3rd Prolog Conference.jpg": 1491,
	"./Port Visit - 3rd Prolog Conference.jpg": 8163,
	"./Registration - 3rd Prolog Conference.jpg": 1936,
	"./Video Testimonials - 3rd PRO Networking Conference.jpg": 6232,
	"./Videos - 3rd Pro Netwroking Conference.jpg": 9733,
	"./Welcome Cocktail - 3rd Prolog Conference.jpg": 3825
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 973;